export default {
  data () {
    return {
      timer: true,
      notification: [],
      errorLength: 2,
    };
  },
  mounted () {
    this.$root.$on('notification', (data) => {
      window.clearInterval(this.timer);

      if (this.notification.length > 4) {
        this.notification.shift();
        this.notification = this.notification;
      }

      this.notification.push({
        id: Math.floor(Math.random() * Math.floor(50505050)),
        show: data.show,
        type: data.type,
        message: data.message || 'Something was wrong',
        listError: data.listError,
      });

      this.timer = window.setInterval(() => {
        this.notification.forEach((item, index) => {
          setTimeout(() => {
            this.hideMessage(item.id);
          }, 10 + (index * 100));
        });

        window.clearInterval(this.timer);
      }, 10000);
    });
  },
  methods: {
    hideMessage (index) {
      this.notification = this.notification.filter((item) => item.id !== index);
      this.errorLength = 2;
    },
    showAllErrors (e, length) {
      this.errorLength = length;
      e.stopPropagation();
    },
  },

};
